module.exports = __webpack_public_path__ + "img/goeatLogo.73bf8262.png";